import React, { useState } from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import '../styles/quill-custom.css';

const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['link', 'image'],
    ['clean'],
  ],
};

const formats = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'list',
  'bullet',
  'link',
  'image',
];

export default function RichTextEditor({
  value,
  onChange,
  placeholder = 'Введите текст…',
}) {
  const [htmlMode, setHtmlMode] = useState(true);

  return (
    <div className="rounded border border-gray-600 bg-gray-800 text-white">
      <div className="flex justify-end border-b border-gray-700 p-2">
        <button
          type="button"
          onClick={() => setHtmlMode((prev) => !prev)}
          className="rounded bg-gray-700 px-3 py-1 text-sm text-white hover:bg-gray-600"
        >
          {htmlMode ? 'Визуальный режим' : 'HTML-режим'}
        </button>
      </div>

      {htmlMode ? (
        <textarea
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          rows={18}
          className="w-full bg-gray-900 p-3 font-mono text-sm text-white outline-none"
        />
      ) : (
        <ReactQuill
          theme="snow"
          value={value || ''}
          onChange={onChange}
          modules={modules}
          formats={formats}
          placeholder={placeholder}
          className="custom-quill"
        />
      )}
    </div>
  );
}